import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from '@angular/router';
import { CardAcceptorConfigService } from "../services/card-acceptor-config.service";
import { CardAcceptorConfigViewModel } from "../models/card-acceptor-config-view-model";
import { PermissionEnum } from "../services/guards/permissions";
import { AuthenticationService } from "../services/authentication.service";
import { ToastrService } from "ngx-toastr";
import { ConfirmationDialogComponent } from "../partials/confirmation-dialog/confirmation-dialog.component";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TerminalConfigViewModel } from "../models/terminal-config-view-model";
import { MerchantService } from "../services/merchant.service";

@Component({
  selector: 'app-merchant-config-management-audit',
  templateUrl: './merchant-config-management-audit.component.html',
  styleUrls: ['./merchant-config-management-audit.component.scss']
})
export class MerchantConfigAuditManagementComponent implements OnInit {
  public dtOptions: DataTables.Settings = {};
  public cardAcceptorConfigs: CardAcceptorConfigViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  public canView = false;

  constructor(private _router: Router, private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService, private _modalService: NgbModal,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService) {


    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantAudit], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      search: {
        caseInsensitive: true
      }
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void> {
    this._ngxUiLoaderService.start();
    this.cardAcceptorConfigs = await this._cardAcceptorConfigService.GetAllConfigs();
    this.dtTrigger.next();
    this._ngxUiLoaderService.stop();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }


  public async ViewCardAcceptorConfig(cardAccteptor: CardAcceptorConfigViewModel): Promise<void> {
    this._router.navigate(['management', 'audit-merchant-config', cardAccteptor.id]);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

}
